export * from './GithubIcon.tsx'
export * from './InstagramIcon.tsx'
export * from './LinkedInIcon.tsx'
export * from './MediumIcon.tsx'
export * from './TwitterIcon.tsx'
export * from './WebIcon.tsx'
export * from './DiscordIcon.tsx'
export * from './RedditIcon.tsx'
export * from './TelegramIcon.tsx'
export * from './TikTokIcon.tsx'
export * from './YouTubeIcon.tsx'
